import { Typography } from "@suraasa/placebo-ui"
import { AiDetectedSubmissionReport } from "api/resources/submissions/types"
import { useEffect, useRef, useState } from "react"
import { useSkillEvidenceStyles } from "utils/hooks/useSkillEvidenceStyles"

import TooltipCursor from "./TooltipCursor"

type Props = {
  submissionId: string
  aiDetectedReportData?: AiDetectedSubmissionReport
}

const AiDetectedSubmission = ({ aiDetectedReportData }: Props) => {
  const styles = useSkillEvidenceStyles()
  const ref = useRef<HTMLParagraphElement>(null)
  const [tooltip, setTooltip] = useState<{
    text: string
    x: number
    y: number
  } | null>(null)

  useEffect(() => {
    if (ref.current) {
      const spans = document.querySelectorAll<HTMLSpanElement>(
        ".suraasa-ai-content-detected"
      )
      console.log(spans)
      const handleMouseEnter = (e: MouseEvent) => {
        const target = e.currentTarget as HTMLSpanElement
        const percentage = target.getAttribute("ai-written-percentage") ?? ""
        setTooltip({
          text: `This seems to be AI Generated.\nAI Detection: ${percentage}%`,
          x: e.clientX,
          y: e.clientY,
        })
      }

      const handleMouseMove = (e: MouseEvent) => {
        setTooltip(prev =>
          prev ? { ...prev, x: e.clientX, y: e.clientY } : prev
        )
      }

      const handleMouseLeave = () => {
        setTooltip(null)
      }

      spans.forEach(span => {
        const percentage = Number(
          span.getAttribute("ai-written-percentage") || 0
        )

        if (percentage >= 20) {
          if (percentage <= 40) {
            span.classList.add("low-percentage")
          } else if (percentage > 40 && percentage <= 60) {
            span.classList.add("medium-percentage")
          } else {
            span.classList.add("high-percentage")
          }

          span.addEventListener("mouseenter", handleMouseEnter)
          span.addEventListener("mousemove", handleMouseMove)
          span.addEventListener("mouseleave", handleMouseLeave)
        }
      })
    }
  }, [aiDetectedReportData?.aiDetectedHtml])

  if (!aiDetectedReportData) return null

  const { aiDetectedHtml, aiCheckStatus } = aiDetectedReportData

  if (aiCheckStatus === "failed") {
    return (
      <Typography className="py-3 text-center" variant="title2">
        We are unable to process this submission.
      </Typography>
    )
  }

  if (aiCheckStatus !== "completed") {
    return (
      <Typography className="py-3 text-center" variant="title2">
        We are still processing this submission it will take a few minutes.
      </Typography>
    )
  }
  return (
    <div>
      {aiDetectedHtml && (
        <div
          ref={ref}
          className={styles.className}
          dangerouslySetInnerHTML={{
            __html: aiDetectedHtml,
          }}
        />
      )}
      {tooltip && (
        <TooltipCursor
          text={tooltip.text}
          coords={{ x: tooltip.x, y: tooltip.y }}
        />
      )}
    </div>
  )
}

export default AiDetectedSubmission
